import React from 'react';

import './menu-item-notification.module.css';

const styles = {
    menuItemNotification: 'menuItemNotification',
};

export const MenuItemNotification = () => <span className={styles.menuItemNotification} />;
